export class UploadfilesViewmodel {
  files: any;
  isDropbox = false;
  isDropboxValue = 'file';
  dropboxUrl: string;

  constructor() {
    this.initializeData();
  }

  initializeData(): void {
    this.files = null;
    this.isDropbox = false;
    this.dropboxUrl = '';
    this.isDropboxValue = 'file';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/viewmodels/uploadfiles-viewmodel.ts